/* ---------------------------------------------------------------------
 *                            Import Packages
 * --------------------------------------------------------------------- */

// React
import React from "react";

// MUI
import { Snackbar, Alert, Slide } from "@mui/material";

/* ---------------------------------------------------------------------
 *                           Common Constants
 * --------------------------------------------------------------------- */

/**
 * 默认欢迎提示
 * @type {string}
 */
export const WELCOME_MESSAGE =
  "您好，我是您的AI运营助理四加。我给您介绍一下我目前的功能：首先您需要在左上角选择您对应的平台，然后下方会列出一个运营流程的引导，点击引导我会帮您列出对应常见情况。";

/**
 * 默认snackbar显示时长
 * @type {object}
 */
const SNACKBAR_DURATION = {
  INFO: 6000,
  ERROR: 12000,
  WARNING: 8000,
  SUCCESS: 6000,
  DEFAULT: 6000,
};

/* ---------------------------------------------------------------------
 *                           Common Components
 * --------------------------------------------------------------------- */

/**
 * Snackbar组件的过渡动画
 * @param {object} props - 属性对象
 * @returns {JSX.Element} - 过渡动画组件
 */
export function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

/**
 * 统一的消息提示组件
 * @param {boolean} [props.open=true] - 是否显示提示
 * @param {function} props.onClose - 关闭时的回调函数
 * @param {string} props.text - 显示的文本内容
 * @param {string} [props.severity='warning'] - 提示类型：'error' | 'warning' | 'info' | 'success'
 * @param {string} [props.width='auto'] - 提示框宽度
 * @param {number} [props.duration] - 显示时长（毫秒），不同类型有默认值
 * @returns {JSX.Element} 消息提示组件
 */
export function SiJiaSnack({
  open = true,
  onClose,
  text,
  severity = "warning",
  width = "auto",
  duration: customDuration,
}) {
  // 根据提示类型设置默认显示时长
  const getDurationBySeverity = (severity) => {
    const severityUpperCase = severity.toUpperCase();
    return SNACKBAR_DURATION[severityUpperCase] || SNACKBAR_DURATION.DEFAULT;
  };

  // 使用自定义时长或根据类型获取默认时长
  const duration = customDuration ?? getDurationBySeverity(severity);

  return (
    <Snackbar
      sx={{ width }}
      autoHideDuration={duration}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={open}
      onClose={onClose}
      TransitionComponent={SlideTransition}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
        {text}
      </Alert>
    </Snackbar>
  );
}
